var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionArchitectureBgShapeYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 384,
    viewBox: "0 0 246 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2349_4353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 322,
    height: 384
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.479e-06 71.0913L100.647 383.614L321.396 312.522L220.749 -0.000487938L-2.479e-06 71.0913Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2349_4353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.659 155.982C395.779 212.801 385.191 283.288 341.012 313.421C312.18 333.084 273.729 331.015 241.976 308.134C223.155 294.569 212.966 275.956 199.387 255.961C158.219 195.368 98.951 130.502 32.733 137.542C13.2713 139.607 37.9419 104.663 41.7167 99.5C116.509 -2.83632 261.68 8.49508 346.084 126.394C352.815 135.792 359.019 145.693 364.659 155.982Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.89 157.23C387.591 211.462 377.488 278.739 335.321 307.497C307.799 326.267 271.104 324.29 240.803 302.454C222.838 289.507 213.11 271.737 200.152 252.661C160.863 194.831 104.287 132.917 41.0905 139.632C22.5179 141.607 46.0622 108.252 49.6663 103.322C121.053 5.6462 259.606 16.458 340.167 128.987C346.585 137.955 352.517 147.404 357.897 157.227L357.89 157.23Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.122 158.477C379.405 210.122 369.788 274.189 329.631 301.574C303.421 319.45 268.474 317.568 239.622 296.768C222.513 284.438 213.257 267.518 200.91 249.355C163.499 194.287 109.625 135.331 49.4431 141.724C31.7568 143.6 54.1748 111.836 57.611 107.145C125.591 14.1307 257.529 24.4318 334.248 131.59C340.364 140.136 346.009 149.137 351.132 158.484L351.122 158.477Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.345 159.726C371.217 208.783 362.075 269.633 323.933 295.652C299.041 312.633 265.841 310.846 238.434 291.092C222.188 279.378 213.39 263.312 201.664 246.048C166.123 193.736 114.951 137.739 57.7831 143.809C40.9859 145.595 62.2777 115.42 65.5359 110.964C130.11 22.6105 255.441 32.3985 328.307 134.18C334.117 142.294 339.476 150.848 344.338 159.728L344.345 159.726Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.573 160.964C363.026 207.433 354.37 265.074 318.239 289.719C294.658 305.806 263.213 304.112 237.249 285.395C221.859 274.299 213.521 259.076 202.417 242.732C168.754 193.182 120.281 140.135 66.128 145.882C50.217 147.57 70.3854 118.994 73.4729 114.769C134.641 31.0764 253.354 40.3448 322.38 136.766C327.885 144.447 332.957 152.553 337.566 160.966L337.573 160.964Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.805 162.211C354.836 206.085 346.662 260.527 312.548 283.795C290.286 298.986 260.589 297.387 236.07 279.717C221.536 269.239 213.67 254.866 203.183 239.432C171.392 192.647 125.618 142.55 74.4824 147.983C59.4606 149.58 78.5027 122.595 81.4195 118.602C139.175 39.572 251.286 48.3251 316.46 139.369C321.656 146.63 326.453 154.275 330.801 162.222L330.805 162.211Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.035 163.46C346.647 204.747 338.956 255.971 306.857 277.874C285.902 292.162 257.964 290.664 234.887 274.032C221.208 264.172 213.807 250.65 203.934 236.118C174.02 192.087 130.948 144.949 82.8266 150.059C68.6839 151.56 86.614 126.159 89.3558 122.41C143.705 48.0406 249.199 56.2741 310.533 141.957C315.423 148.786 319.934 155.984 324.028 163.462L324.035 163.46Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.259 164.709C338.453 203.41 331.248 251.423 301.156 271.943C281.513 285.338 255.327 283.924 233.705 268.345C220.882 259.102 213.942 246.424 204.698 232.809C176.662 191.54 136.282 147.354 91.1853 152.148C77.9317 153.559 94.7355 129.749 97.3066 126.23C148.25 56.5223 247.129 64.245 304.625 144.547C309.21 150.944 313.433 157.694 317.274 164.704L317.259 164.709Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.492 165.956C330.273 202.067 323.547 246.873 295.467 266.019C277.141 278.519 252.703 277.199 232.523 262.658C220.56 254.042 214.088 242.204 205.454 229.502C179.288 190.989 141.617 149.76 99.5273 154.233C87.1599 155.545 102.84 133.334 105.233 130.049C152.77 65.0022 245.039 72.2029 298.685 147.137C302.961 153.114 306.909 159.402 310.489 165.947L310.492 165.956Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.719 167.194C322.082 200.719 315.832 242.308 289.765 260.089C272.75 271.695 250.06 270.47 231.333 256.973C220.232 248.973 214.218 237.989 206.199 226.188C181.911 190.438 146.933 152.161 107.867 156.318C96.3889 157.54 110.943 136.919 113.165 133.866C157.299 73.4887 242.95 80.1698 292.754 149.734C296.724 155.279 300.386 161.12 303.712 167.196L303.719 167.194Z",
    stroke: "#DD9326",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionArchitectureBgShapeYellow);
export default __webpack_public_path__ + "static/media/solution_architecture_bg_shape_yellow.0838bdcfe1af4d2ba709b63dfd163de2.svg";
export { ForwardRef as ReactComponent };